import request from "@/utils/request";


export function attendFair(data) {
  return request({
    url:'/job/fair/attend',
    method: 'post',
    data
  })
}

export function hasAttendedFair(data) {
  return request({
    url:'/job/fair/has/attended',
    method: 'post',
    data
  })
}

export function getTopFair(top) {
  return request({
    url: '/job/fair/top/list',
    method: 'get',
    params:{top:top}
  })
}

export function getTopFair2(top, fairState) {
  return request({
    url: '/job/fair/top/list2',
    method: 'get',
    params:{top:top, fairState: fairState}
  })
}

export function getAllAttendFair() {
  return request({
    url: '/job/fair/attends/list',
    method: 'get'
  })
}

export function getFairDetail(fairId) {
  return request({
    url: '/job/fair/details',
    method: 'get',
    params:{fairId:fairId}
  })
}

export function getFairUserList(data) {
  return request({
    url: '/job/fair/user/center',
    method: 'get',
    params: data
  })
}

export function getFairEntList(data) {
  return request({
    url: '/job/fair/square',
    method: 'get',
    params: data
  })
}

export function getFairList(data) {
  return request({
    url: '/job/fair/list',
    method: 'get',
    params: data
  })
}

export function getFairList2(data) {
  return request({
    url: '/job/fair/list2',
    method: 'get',
    params: data
  })
}

export function enterpriseFairList(data) {
  return request({
    url:'/job/fair/enterpriseFairList',
    method: 'post',
    data
  })
}

export function userCanTalk() {
  return request({
    url: '/job/fair/user/can/talk',
    method: 'get'
  })
}

export function addFairView(data) {
  return request({
    url:'/job/fair/view/record',
    method: 'post',
    data
  })
}

export function fairStatistics() {
  return request({
    url: '/job/fair/query/statistics',
    method: 'get'
  })
}

export function fairOnlineJobs() {
  return request({
    url: '/job/fair/query/online/job/statistics',
    method: 'get'
  })
}

export function fairOnlineUsers() {
  return request({
    url: '/job/fair/query/online/user/statistics',
    method: 'get'
  })
}

export function updateAttendInfo(data) {
  return request({
    url:'/job/fair/update_attend_info',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/fair.js